import { TableItemState } from '../../../component-library/table/table-item-state.enum';
import { CONFIG } from '../../../core/config';
import { Unit } from '../../unit';
import { ViewModel } from '../../view-model';
import { TemplateAttributeDataType } from '../hierarchy-templates/template-attribute-data-type.enum';

export class TableTemplateColumn implements ViewModel {
  public friendlyTypeNameSingular: string = 'Table template columns';
  public apiRoute: string = CONFIG.apiRoutes.tableTemplateColumns;

  public tableTemplateColumnId: string;
  public name: string;
  public columnIndex: number;
  public uomId: string;
  public uom: Unit;
  public dataType: TemplateAttributeDataType;
  public tableTemplateId: string;
  public state: TableItemState = TableItemState.Unchanged;
  public refId: string;

  public json(): this {
    return this;
  }

  public loadFromJson(data: any): void {
    this.tableTemplateColumnId = data.tableTemplateColumnId;
    this.name = data.name;
    this.dataType = data.dataType;
    this.tableTemplateId = data.tableTemplateId;
    this.uomId = data.uomId;
    this.columnIndex = data.columnIndex;

    if (data.unit) {
      this.uom = new Unit();
      this.uom.loadFromJson(data.unit);
    }
  }
}
